module.exports = __webpack_public_path__ + "img/interaction-bar-search-hyundai.2b2f82f9.png";